$('.rezervace .close').on('click', function () {
    $('.rezervace').toggleClass('visible');
});